import { DropdownMenu } from "@kobalte/core/dropdown-menu";
import { A, useLocation } from "@solidjs/router";
import { For, createEffect, createSignal, on } from "solid-js";

export const Menu = (props) => {
	const location = useLocation();
	const [open, setOpen] = createSignal( false );

	// Items do not close the menu themselves (closeOnSelect is off below): Kobalte
	// selects on pointer-up and would unmount the list before the click that follows
	// it, so on a touch screen the link never fired. Close once the page has changed.
	createEffect( on( () => location.pathname, () => setOpen( false ), { defer: true } ) );

	// Not modal: a modal menu locks the page's scrolling and pads the page while it is
	// open, which squeezed the whole page (and the footer) out of shape on a phone.
	return (
		<>
		{/* Phone: the links sit inline in the folded-away nav. A floating list over the
		    other nav items put them under the tap, and the one beneath got the click. */}
		<div class="md:hidden py-3">
			<p class="font-semibold text-gray-900">{props.caption}</p>
			<div class="mt-1 flex flex-col">
				<For each={props.items}>
					{(item) => (
						<A href={item.href} class="block py-2 pl-4 text-sm text-gray-700 no-underline">
							{item.caption}
						</A>
					)}
				</For>
			</div>
		</div>

		{/* md and up: the drop-down. */}
		<div class="hidden md:block">
		<DropdownMenu open={open()} onOpenChange={setOpen} modal={false} preventScroll={false}>
			<DropdownMenu.Trigger class="bg-transparent outline-none border-none inline-flex py-3 md:py-2 md:px-3 text-base font-semibold text-gray-900 hover:bg-slate-50">
				{props.caption}
				<svg
					viewBox="0 0 20 20"
					fill="currentColor"
					aria-hidden="true"
					class="-mr-1 size-5 text-gray-400">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
					/>
				</svg>
			</DropdownMenu.Trigger>
			<DropdownMenu.Portal>
				<DropdownMenu.Content class="z-50 w-56 max-w-[calc(100vw-2rem)] origin-top-right rounded-md bg-white shadow-lg outline-1 outline-black/5 transition">
					<div class="py-1">
						<For each={props.items}>
							{(item) => (
								<DropdownMenu.Item
									as={A}
									href={item.href}
									closeOnSelect={false}
									onClick={() => setTimeout( () => setOpen( false ) )}
									class="block px-4 py-3 md:py-2 text-sm text-gray-700 no-underline focus:bg-gray-100 focus:text-gray-900">
									{item.caption}
								</DropdownMenu.Item>
							)}
						</For>
					</div>
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu>
		</div>
		</>
	);
};
